import { SVGPercent, SVGShippingCar } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from './DeliveryDiscount.scss'
import { FREE_SHIPPING_LIMIT } from 'Utils/helpers/constants';
import { numberFormatter } from 'Utils/helpers/formatters';

type PropType = {
  remaining: number
  hasGiftBasket?: boolean
}

const DeliveryDiscount: React.SFC<PropType> = (props) => {
  const { remaining, hasGiftBasket } = props

  return (
    <div className={cl.deliveryDiscount}>
      <div className={cn(cg.gridX, cg.alignMiddle)}>
        <div className={cn(cg.cell, cg.largeShrink)}>
          <h2 className={cn(cg.gridX, cg.alignMiddle, cl.h2)}>
            <span className={cn(cg.cell, cg.shrink)} aria-hidden={true}>
              <SVGShippingCar width={32} height={32} />
            </span>

            <span className={cn(cg.cell, cg.auto)}>
              Szállítási kedvezmény
            </span>
          </h2>
        </div>

        <div className={cn(cg.cell, cg.largeAuto)}>
          {hasGiftBasket ? (
            <p>Megrendelése ajándékkosarat tartalmaz, <br />ezért a kiszállítást GRoby futárral díjmenetesen vállaljuk.</p>
          ):(
            remaining <= 0 ? (
              <p>Megrendelésed eléri az <strong>{numberFormatter(FREE_SHIPPING_LIMIT)} Ft</strong> értéket, ezért díjmentesen házhozszállítjuk!</p>
            ):(
              <p>Amennyiben még <strong>{numberFormatter(remaining)} Ft</strong> értékben vásárolsz, megrendelésedet díjmentesen házhozszállítjuk!</p>
            )
          )}
        </div>
      </div>

      <div className={cl.deliveryDiscount__backgroundWrapper} aria-hidden="true">
        <SVGPercent />
      </div>
    </div>
  )
}

export default DeliveryDiscount
